import { createDeprecationWarning } from '../core/sdk-exceptions';
/**
 * Given a JSON-serializable object, encode as a Base64 string.
 */
export function encodeJSON(options) {
    return btoa(JSON.stringify(options));
}
/**
 * Given a Base64 JSON string, decode a JavaScript object.
 */
export function decodeJSON(queryString) {
    return JSON.parse(atob(queryString));
}
// --- DEPRECATED!
/**
 * Given a JSON-serializable object, encode as a Base64 string.
 *
 * @deprecated
 */
/* istanbul ignore next */
export function encodeQueryParameters(options) {
    createDeprecationWarning({
        method: 'encodeQueryParameters()',
        removalVersions: { 'magic-sdk': 'v3.0.0', '@magic-sdk/react-native': 'v3.0.0' },
        useInstead: 'encodeJSON()',
    }).log();
    return btoa(JSON.stringify(options));
}
/**
 * Given a Base64 JSON string, decode a JavaScript object.
 *
 * @deprecated
 */
/* istanbul ignore next */
export function decodeQueryParameters(queryString) {
    createDeprecationWarning({
        method: 'decodeQueryParameters()',
        removalVersions: { 'magic-sdk': 'v3.0.0', '@magic-sdk/react-native': 'v3.0.0' },
        useInstead: 'decodeJSON()',
    }).log();
    return JSON.parse(atob(queryString));
}
//# sourceMappingURL=base64-json.js.map